import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { selectAuthorized, selectContact, SetFilterFormExpanded } from './customer-filter.actions';

export const featureKey = 'customer-filter';

export interface State {
  filterFormExpanded: boolean;
  selectedContactId: number | null;
  selectedAuthorized: boolean | null;
}

export interface AppState {
  [featureKey]: State;
}

export const initialState: State = {
  filterFormExpanded: false,
  selectedContactId: null,
  selectedAuthorized: null,
};

const customerFilterReducer = createReducer(
  initialState,
  on(selectContact, (state, { contactId }): State => ({ ...state, selectedContactId: contactId })),
  on(selectAuthorized, (state, { authorized }): State => ({ ...state, selectedAuthorized: authorized })),
  on(SetFilterFormExpanded, (state, { expanded }): State => ({ ...state, filterFormExpanded: expanded })),
);
export function reducer(state: State | undefined, action: Action) {
  return customerFilterReducer(state, action);
}

export const selectCustomerFilterState = createFeatureSelector< State>(featureKey);
export const selectFilterFormExpanded = createSelector(selectCustomerFilterState, (state: State) => state.filterFormExpanded);
